import React from 'react';

const iconAndTextColor = {
  error: "text-danger fas fa-exclamation-triangle",
  info: "text-info fas fa-info-circle",
  success: "text-success far fa-smile",
  warning: "text-warning fas fa-exclamation-triangle"
}

export default function BootstrapToast ({ level, title, onDismiss, transitionState, children }) {
  return (
    <div className={`toast ${(!transitionState || transitionState === "entered") ? "show" : ""} fade d-flex flex-row align-items-top`}>
      <div>
        <div className="toast-header text-align-center border-bottom-0 pb-0">
          {level && <i className={`${iconAndTextColor[level]}`}></i>}
          {title && <strong className="ml-1 content-spacer-right">{title}</strong>}
        </div>
        <div className="toast-body pt-2">{children}</div>
      </div>
      <div className="ml-auto pt-2">
        <button
          type="button"
          className="mb-1 px-2 close"
          aria-label="Close"
          onClick={id => onDismiss(id)}
        >
          <i className="far fa-times"></i>
        </button>
      </div>
    </div>
  );
};
